module.exports = __webpack_public_path__ + "assets/img/detail-img4-f0ba86b4.png";